export const AB_SPLIT_EDITOR_NAME = 'absplit';

export const EVENLY_DISTRIBUTE_TEST_ID = 'distribute-evenly;';
export const INVALID_SPLIT_GROUPS_TEST_ID = 'invalid-split-groups';
